import sideImage from "../images/afro-solar/solution-for-real-state/Untitled design.webp";

const industrialsSolutions = [
  {
    title: "Increased Property Value",
    description:
      "Enjoy up to a 40% increase in property value and raise your ask price at no additional cost.",
  },
  {
    title: "Increased Energy Savings",
    description:
      "Improved energy savings for an entire community due to reduced utility bills.",
  },
  {
    title: "Reduced Carbon Footprint",
    description:
      "Every megawatt installed lowers your carbon footprint by 25,000 tons.",
  },
  {
    title: "No capital Investments,",
    description:
      "Offer your clients a better value proposition at no additional cost.​",
  },
  {
    title: "Value driven community ",
    description:
      "Promoting a healthier ecosystem that nurtures a positive sense of belonging and community.​",
  },
  {
    title: "Healthier Ecosystem",
    description:
      "Create healthier, cleaner purpose driven communities and demonstrate civic leadership.",
  },
];

const RealStateSolution = () => {
  return (
    <div className="container-fluid pt-7">
      <div className="ms-13 me-13">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-6 my-auto order-1 order-lg-0">
            {industrialsSolutions.map((solution, index) => (
              <div className="row" key={solution.title}>
                <h2
                  className="col-2 text-24 gilroy-bold bg-american-yellow text-center me-4"
                  style={{
                    height: "40px",
                    width: "40px",
                    borderRadius: "50%",
                    lineHeight: "40px",
                  }}
                >
                  {index + 1}
                </h2>
                <div className="col-10">
                  <h3 className="fs-18 gilroy-bold">{solution.title}</h3>
                  <p className="fs-16">{solution.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="col-12 col-md-12 col-lg-6 text-center order-0 order-lg-1 mb-5 mb-lg-0">
            <img
              src={sideImage}
              alt="solution for industrial"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealStateSolution;
